import { WithStyle } from '@medly-components/utils';
import { FC, MouseEvent, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSideNavContext } from 'context';
import { MapTourContext } from 'context/MapTourContext';
import { useIsMobile } from 'hooks';
import { TourType } from 'pages/Map/components/MapTour';
import { useSideNavHoverContext } from '../SideNav.context';
import { NavItemStyled } from './NavItem.styled';
import { NavItemProps } from './types';

export const NavItem: FC<NavItemProps> & WithStyle = props => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const isHovered = useSideNavHoverContext();
    const { isExpanded, setExpandedState } = useSideNavContext();
    const { path, onClick, children, isActive, title } = props;
    const { isCurrentTourItem } = useContext(MapTourContext);
    const isMapTourActiveElement = title === 'Legends' && isCurrentTourItem(TourType.INFO_ABOUT_LEGENEDS);

    const onClickHandler = (event: MouseEvent<HTMLLIElement>) => {
        if (path) {
            navigate(path);
            isMobile && setExpandedState(false);
        }
        onClick?.(event);
    };

    return (
        <NavItemStyled
            id={`${title}-nav-item`}
            isHovered={isHovered}
            isExpanded={isExpanded}
            isActive={isActive}
            onClick={onClickHandler}
            isMapTourActiveElement={isMapTourActiveElement}
        >
            {children}
        </NavItemStyled>
    );
};

NavItem.displayName = 'NavItem';
NavItem.Style = NavItemStyled;
